import { ZIndex } from "@/domains/design/constants";
import styled from "@emotion/styled";

export const VersionNoticeCard = styled.div(({ theme }) => ({
  alignItems: "stretch",
  backgroundColor: theme.colors.surface.modal,
  border: `1px solid ${theme.colors.border.default}`,
  borderRadius: theme.spacing["2"],
  bottom: 0,
  boxShadow: "0 6px 18px rgba(69, 78, 104, 0.18)",
  display: "flex",
  flexDirection: "column",
  gap: theme.spacing["3"],
  margin: theme.spacing["2"],
  maxWidth: "280px",
  padding: theme.spacing["3"],
  position: "fixed",
  right: 0,
  width: "calc(100vw - 32px)",
  zIndex: ZIndex.AppVersionNotice,
}));
